import React, {useEffect} from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import {
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableColumnHeaderCell,
    DataTableContent,
    DataTableHeaderRow,
    DataTablePagination,
    DataTableRow,
    DataTableToolbar,
    TextButton,
} from "@episerver/ui-framework";
import {
    contactsInOrganizationPaginationSelector,
    onChangeContactPage,
    onChangeContactRowPerPage,
} from "../reducers/contactListInOrganizationReducer";
import { Contact, ContactsType, ContactType } from "../../ContactManager/model/contact";
import { useHistory } from "react-router-dom";
import { onChangeDialog } from "../reducers/addContactsToOrganizationReducer";
import { organizationSelector } from "../reducers/organizationDetailReducer";
import { fetchContactsInOrganization } from "../reducers/asyncThunks";

interface ContactListInOrganizationProps {
    organizationId: string;
}

const ContactListInOrganization = (props: ContactListInOrganizationProps) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const organization = useSelector(organizationSelector);
    const { rowsPerPage, startRow, rowsPerPageOptions, totalRowCount } = useSelector(
        contactsInOrganizationPaginationSelector
    );

    useEffect(() => {
        dispatch(fetchContactsInOrganization(props.organizationId));
    }, []);

    const columns: Array<{ selector: string; title: string; sortable: boolean }> = [
        { selector: "FullName", title: "Full Name", sortable: true },
        { selector: "Email", title: "Email", sortable: true },
        { selector: "LastOrderDate", title: "Last Order Date", sortable: true },
        { selector: "CustomerGroup", title: "Customer Group", sortable: true },
    ];

    const renderRow = (rowData: Contact): React.ReactElement => {
        let pathContactType = ContactType[rowData.customerGroupId] === ContactType[ContactType.AccountAdmin]
            ? ContactsType[ContactsType.Users]
            : ContactsType[rowData.customerGroupId];

        return (
            <DataTableRow rowId={rowData.primaryKeyId!} key={rowData.primaryKeyId}>
                <DataTableCell>
                    <a
                        href=""
                        className="underline-link"
                        onClick={(e) => {
                            e.preventDefault();
                            history.push({
                                pathname:  `/${pathContactType}/Edit/` + rowData.primaryKeyId,
                            });
                        }}
                    >
                        {rowData.fullName}
                    </a>
                </DataTableCell>
                <DataTableCell>{rowData.email ?? ""}</DataTableCell>
                <DataTableCell>
                    {rowData.lastOrder != null ? new Date(rowData.lastOrder).toLocaleDateString() : ""}
                </DataTableCell>
                <DataTableCell>{rowData.customerGroup ?? ""}</DataTableCell>
            </DataTableRow>
        );
    };

    return (
        <div className="child-organization-list">
            <DataTable>
                <DataTableToolbar className="child-organization-list__toolbar">
                    <div>
                        <TextButton
                            onClick={() =>
                                dispatch(
                                    onChangeDialog({
                                        open: true,
                                    })
                                )
                            }
                        >
                            Add
                        </TextButton>
                    </div>
                </DataTableToolbar>
                <DataTableContent>
                    <DataTableHeaderRow>
                        <React.Fragment>
                            {columns.map((column) => {
                                return (
                                    <DataTableColumnHeaderCell key={column.selector}>
                                        {column.title}
                                    </DataTableColumnHeaderCell>
                                );
                            })}
                        </React.Fragment>
                    </DataTableHeaderRow>
                    <DataTableBody>
                        {organization.contacts.map((row: Contact, index: number) => {
                            if (index < startRow || index >= startRow + rowsPerPage) {
                                return <React.Fragment key={row.primaryKeyId}></React.Fragment>;
                            }
                            return renderRow(row);
                        })}
                    </DataTableBody>
                </DataTableContent>
                <DataTablePagination
                    startRow={startRow}
                    totalRowCount={totalRowCount}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={rowsPerPageOptions}
                    onChangePage={(startRow) => dispatch(onChangeContactPage(startRow))}
                    onChangeRowsPerPage={(rowsPerPage) => dispatch(onChangeContactRowPerPage(rowsPerPage))}
                />
            </DataTable>
        </div>
    );
};

export default ContactListInOrganization;
